import 'client-only';

import { atom, useAtom } from 'jotai';

const navigatingAtom = atom(false);

export const useNavigating = () => {
  const [isNavigating, setIsNavigating] = useAtom(navigatingAtom);

  return [isNavigating, setIsNavigating] as const;
};
